/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  SET_SCREENSHOT: 'SET_SCREENSHOT'
};
